export const SAFE_RESULT_PREVIEW = {
  demonstration_only: true,
  score: 75,
  transcription: "بِسْمِ اللَّهِ الرَّحْمَنِ الرَّحِيمِ",
  word_statuses: [
    { word: "بِسْمِ", status: "correct" },
    { word: "اللَّهِ", status: "correct" },
    { word: "الرَّحْمَنِ", status: "replace", recognized_word: "الرَّحْمٰنِ" },
    { word: "الرَّحِيمِ", status: "correct" },
  ],
  rule_contexts: [
    { rule: "lam_jalalah" },
    { rule: "madd_tabii" },
  ],
  tajweed_coaching: {
    actionable_tajweed_correction_count: 0,
    items: [
      {
        source: "textual_asr",
        assessment: "review",
        target_text: "الرَّحْمَنِ",
        message: "La transcription de ce mot doit être vérifiée à l’écoute.",
        next_action: "Réécouter la référence puis comparer calmement.",
        rule_validation_status: "ctc_alignment_diagnostic_only",
      },
    ],
  },
  feedback: [
    {
      title: "Écoute puis répète",
      message: "Travaille uniquement le passage signalé avant une nouvelle récitation complète.",
      next_action: "Réécouter le mot puis le verset.",
    },
  ],
  acoustic_analysis: {
    expected_word_evidence: {
      alignment_status: "contextually_verified_words_only",
      expected_word_count: 4,
      correct_word_count: 3,
      reliable_word_count: 3,
      words: [
        {
          expected_index: 0,
          expected_word_surface: "بِسْمِ",
          text_status: "correct",
          acoustic_evidence: {
            quality_gate: "passed",
            quality_flags: [],
            start_seconds: 0.12,
            end_seconds: 0.64,
          },
        },
        {
          expected_index: 1,
          expected_word_surface: "اللَّهِ",
          text_status: "correct",
          acoustic_evidence: {
            quality_gate: "passed",
            quality_flags: [],
            start_seconds: 0.68,
            end_seconds: 1.21,
          },
        },
        {
          expected_index: 2,
          expected_word_surface: "الرَّحْمَنِ",
          text_status: "replace",
          acoustic_evidence: {
            quality_gate: "review",
            quality_flags: ["signal_too_quiet"],
            start_seconds: 1.26,
            end_seconds: 2.08,
          },
        },
        {
          expected_index: 3,
          expected_word_surface: "الرَّحِيمِ",
          text_status: "correct",
          acoustic_evidence: {
            quality_gate: "passed",
            quality_flags: [],
            start_seconds: 2.12,
            end_seconds: 2.84,
          },
        },
      ],
    },
    phoneme_measurements: {
      targets: [
        { expected_index: 0, measurement_status: "measured" },
        { expected_index: 1, measurement_status: "measured" },
        { expected_index: 2, measurement_status: "review_required" },
        { expected_index: 3, measurement_status: "measured" },
      ],
    },
    runtime_rule_evidence: {
      calibration_candidate_context_count: 2,
      items: [
        {
          expected_index: 1,
          curriculum_rule_id: "tajweed.lam.jalalah",
          family: "tafkhim",
          evidence_status: "measurement_available_calibration_required",
        },
        {
          expected_index: 3,
          curriculum_rule_id: "tajweed.madd.tabii",
          family: "madd",
          evidence_status: "measurement_available_calibration_required",
        },
      ],
    },
  },
};
